<template>
    <transition name="slide">
        <div v-if="show" class="fixed-footer fixed bottom-0 left-0 right-0 zi-100 white-bkg " :class="footerClass">
            <div class="p-2 px-5">
                <slot></slot>
            </div>
        </div>
    </transition>
</template>

<script>
export default {
    props: {
        footerClass: {
            type: String,
            required: false,
            default: 'bt-1'
        }
    },

    data() {
        return {
            show: true
        }
    }
}
</script>

<style lang="scss" scoped>
    .fixed-footer { padding-left: 50px; }

    .slide-enter-active,
    .slide-leave-active { transition: all 1s ease; }
    
    .slide-enter,
    .slide-leave-to { transform: translateY(100%); }
</style>
